import { RecommendedCompsStatistics } from '@aloft/toolkit-shared';
import { Flex, Icon, Typography } from '@aloft/toolkit-sui';
import { Box } from '@aloft/toolkit-sui/chakra';

export const FilterStatistics = ({
  statistics,
  isLoading,
}: {
  statistics?: RecommendedCompsStatistics;
  isLoading: boolean;
}) => (
  <Flex>
    <Flex alignItems="center" marginRight="15px">
      <Box position="relative" marginRight="5px" height="24px">
        <Icon icon="map-pin-filled" size="lg" color="pinSold" />
        <Box
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          fontSize="xs"
          fontWeight="bold"
          color="white"
          lineHeight="1"
          pointerEvents="none"
        >
          S
        </Box>
      </Box>
      <Typography variant="body1" color="textSecondary">
        Sold:&nbsp;
      </Typography>
      <Typography variant="body1">
        {!isLoading && statistics?.listingsSoldCount !== undefined
          ? statistics.listingsSoldCount.toString()
          : '-'}
      </Typography>
    </Flex>
    <Flex alignItems="center" marginRight="15px">
      <Box position="relative" marginRight="5px" height="24px">
        <Icon icon="map-pin-filled" size="lg" color="pinActive" />
        <Box
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          fontSize="xs"
          fontWeight="bold"
          color="white"
          lineHeight="1"
          pointerEvents="none"
        >
          A
        </Box>
      </Box>
      <Typography variant="body1" color="textSecondary">
        Active:&nbsp;
      </Typography>
      <Typography variant="body1">
        {!isLoading && statistics?.listingsActiveCount !== undefined
          ? statistics.listingsActiveCount.toString()
          : '-'}
      </Typography>
    </Flex>
    <Flex alignItems="center" marginRight="15px">
      <Box position="relative" marginRight="5px" height="24px">
        <Icon icon="map-pin-filled" size="lg" color="pinPending" />
        <Box
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          fontSize="xs"
          fontWeight="bold"
          color="white"
          lineHeight="1"
          pointerEvents="none"
        >
          P
        </Box>
      </Box>
      <Typography variant="body1" color="textSecondary">
        Pending:&nbsp;
      </Typography>
      <Typography variant="body1">
        {!isLoading && statistics?.listingsPendingCount !== undefined
          ? statistics.listingsPendingCount.toString()
          : '-'}
      </Typography>
    </Flex>
    <Flex alignItems="center" marginRight="15px" marginLeft="10px">
      <Typography variant="body1" color="textSecondary">
        Sales in the last:&nbsp;
      </Typography>
    </Flex>
    <Flex alignItems="center" marginRight="15px">
      <Typography variant="body1" color="textSecondary">
        0-3 months:&nbsp;
      </Typography>
      <Typography variant="body1">
        {!isLoading && statistics?.last3MonthsListingsCount !== undefined
          ? statistics.last3MonthsListingsCount.toString()
          : '-'}
      </Typography>
    </Flex>
    <Flex alignItems="center" marginRight="15px">
      <Typography variant="body1" color="textSecondary">
        4-6 months:&nbsp;
      </Typography>
      <Typography variant="body1">
        {!isLoading && statistics?.last6MonthsListingsCount !== undefined
          ? statistics.last6MonthsListingsCount.toString()
          : '-'}
      </Typography>
    </Flex>
    <Flex alignItems="center" marginRight="15px">
      <Typography variant="body1" color="textSecondary">
        7-12 months:&nbsp;
      </Typography>
      <Typography variant="body1">
        {!isLoading && statistics?.last12MonthsListingsCount !== undefined
          ? statistics.last12MonthsListingsCount.toString()
          : '-'}
      </Typography>
    </Flex>
  </Flex>
);
